import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { UserService } from '../../service/user.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  isLoggedIn: boolean = false;
  name: string;
  email: string;
  uid: string;
  spec: string;
  titula: string;
  isAdmin: boolean;
  constructor(private userService: UserService, private router: Router) { }

  ngOnInit() {
    this.userService.statusChange.subscribe(userData => {
      if (userData) {
        this.name = userData.name;
        this.email = userData.email;
        this.uid = userData.uid;
        this.spec = userData.spec;
        this.isAdmin = userData.isAdmin;
        this.titula = userData.titula;
      } else {
        this.name = null;
        this.email = null;
        this.uid = null;
        this.spec = null;
        this.isAdmin = false;
        this.titula = null;
      }
    });

    firebase.auth().onAuthStateChanged(async userData => {

      if (userData) {
        this.isLoggedIn = true;

        const user = await this.userService.getProfile(); //kad se refreshuje ako ima usera ovo radi. Pri prvom ulazku ide ono gore
        if (user && user.name) {
          this.name = user.name;
          this.email = user.email;
          this.uid = user.uid;
          this.spec = user.spec;
          this.isAdmin = user.isAdmin;
          this.titula = user.titula;
        }
        this.router.navigate(['/']);
      } else {

        this.isLoggedIn = false;

        this.router.navigate(['/login']);
      }
    });
  }
  onlogout() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        this.userService.remove();
        this.isLoggedIn = false;
      });
  }
}
